// Klick-Uebernahme-Banner (Bauplan Punkt 2): zeigt, welches Feld gerade "scharfgeschaltet" ist
// ("Aktiv: Pos X · <Feld> — jetzt links im PDF auf den Wert klicken ..."), solange pickTarget
// gesetzt ist. Ohne aktives Ziel ein dezenter Tipp-Text (immer sichtbar, kein toter Hinweis).

import React from 'react';
import { MousePointerClick } from 'lucide-react';

const AbPickHintBanner = ({ isDarkMode, t, pickTarget }) => {
  const textMuted = isDarkMode ? 'text-white/45' : 'text-slate-500';
  if (!pickTarget) {
    return (
      <p className={`text-xs flex items-center gap-1.5 ${textMuted}`}>
        <MousePointerClick className="w-3.5 h-3.5" />{t('abPdf.pickHintIdle')}
      </p>
    );
  }
  // 'einteilung' ist KEIN SAP-Feld aus ab.de/en.js (Dateien duerfen hier nicht angefasst werden) —
  // eigenes Label aus abPdf.* verwenden, sonst faellt t() still auf den nackten Key zurueck.
  const fieldLabel = pickTarget.field === 'einteilung' ? t('abPdf.einteilungLabel') : t(`ab.field.${pickTarget.field}`);
  return (
    <p className={`text-xs flex items-center gap-1.5 px-3 py-2 rounded-lg ${isDarkMode ? 'bg-indigo-500/15 text-indigo-200' : 'bg-indigo-50 text-indigo-700'}`}>
      <MousePointerClick className="w-3.5 h-3.5 flex-shrink-0" />
      {t('abPdf.pickHintActive', { line: pickTarget.lineNo, field: fieldLabel })}
    </p>
  );
};

export default AbPickHintBanner;
